import { useState, useEffect, useCallback } from "react";

export const useForm = (formData, validation, callback) => {
  const [state, setState] = useState(formData);
  const [disable, setDisable] = useState(true);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const serializedFormData = JSON.stringify(formData || {});

  const validateState = useCallback(() => {
    const hasError = Object.keys(validation).some((key) => {
      const isInputFieldRequired = validation[key]?.required;
      const stateValue = state[key]?.value;
      const stateError = state[key]?.error;
      return (isInputFieldRequired && !stateValue) || stateError;
    });
    return hasError;
  }, [state, validation]);

  useEffect(() => {
    setDisable(validateState());
  }, [validateState]);

  useEffect(() => {
    if (!isFormChanged) {
      setState(formData);
    }
  }, [serializedFormData, isFormChanged]);

  const handleChange = (name, value, other) => {
    const field = validation[name];
    let error = "";
    setIsFormChanged(true); // Set form as changed whenever there's any input
    if (name === "phone" || name === "billingPhone") {
      value = value.replace(/[^0-9]/g, ""); // only digits
    }
    if (name === "email") {
      value = value.toLowerCase();
    }
    if (["quantity", "discount", "tax", "weight", "account", "amount", "taxAmount", "idNumber", "taxRefNo", "medicalAidNo", "providentFundNo"].includes(name) && Number(value) < 0) {
      return;
    }
    if (["tax", "discount", 'taxAmount'].includes(name) && Number(value) > 100) {
      return;
    }
    if (name === "projects") {
      value = Array.isArray(value) ? value : [];
    }
    if (name === "taxAmount") {
      const amountVal = state?.amount?.value;

      if (!amountVal || Number(amountVal) === 0) {
        value = 0;
      } else if (Number(value) > Number(amountVal)) {
        // error = "Tax amount cannot be greater than amount";
      }
    }
    if (field) {
      if (!value && !field.required) {
        error = "";
      } else if (!value && field.required) {
        error = field.validator?.errEmpty
      } else {
        if (field.validator.regEx && field.validator.pattern instanceof RegExp && !field.validator.regEx.test(value)) {
          error = field.validator.error;
        }
        if (!Number(value) && field.validator.regEx && field) {
          if (!field.validator.regEx.test(value)) {
            error = field.validator.error;
          }
        }
        if (field.validator?.min !== undefined && Number(value) < field.validator.min) {
          error = field.validator?.minError || `Value cannot be less than ${field.validator.min}`;
        }
        if (field.validator?.max !== undefined && Number(value) > field.validator.max) {
          error = field.validator?.maxError || `Value cannot be greater than ${field.validator.max}`;
        }
        if (Number(value) && !!field.validator?.mobileValidate?.regex) {
          if (!field.validator.mobileValidate.regEx.test(value)) {
            error = field.validator.mobileValidate.error;
          }
        }
        if (field?.length?.value) {
          if (field?.length?.value <= value.length) {
            error = field.length.error;
          }
        }

        if (name === "confirmPassword") {
          if (value !== other) {
            error = field.validator.error;
          }
        }
        if (name === "description" && value.length > 500) {
          error = "Description cannot exceed 500 characters";
        }
      }
    }

    setState((prevState) => ({
      ...prevState,
      [name]: { ...prevState[name], value: value || "", error },
    }));
  };
  const handleFocus = (name, value) => {
    setState((prevState) => ({
      ...prevState,
      [name]: { ...prevState[name], focus: value },
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const resetCallback = () => {
       setIsFormChanged(false);
    };
    callback(state, resetCallback);
  };

  return { state, disable, handleChange, handleSubmit, handleFocus, isFormChanged };
};
